import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import api from "../api";

const CategoryNav = ({ hiddenCategories = [] }) => {
  const [categories, setCategories] = useState([]);
  const listRef = useRef(null);
  const isSeoPage = false;

  useEffect(() => {
    api.getCategories()
      .then(data => {
        const parentMap = {};
        data.forEach(c => { parentMap[c.id] = c; });

        const parents = data.filter(c => !c.parentId);
        parents.sort((a, b) => {
          if ((a.sortOrder || 0) !== (b.sortOrder || 0)) {
            return (a.sortOrder || 0) - (b.sortOrder || 0);
          }
          return (a.name || '').localeCompare(b.name || '', 'vi');
        });

        const orderedList = [];
        parents.forEach(parent => {
          if (parent.showOnPage !== false) {
            orderedList.push({
              ...parent,
              thumbnail: parent.thumbnail || ""
            });
          }

          const children = data.filter(c => c.parentId === parent.id);
          children.sort((a, b) => {
            if ((a.sortOrder || 0) !== (b.sortOrder || 0)) {
              return (a.sortOrder || 0) - (b.sortOrder || 0);
            }
            return (a.name || '').localeCompare(b.name || '', 'vi');
          });

          children.forEach(child => {
            if (child.showOnPage !== false) {
              orderedList.push({
                ...child,
                thumbnail: child.thumbnail || parent.thumbnail || ""
              });
            }
          });
        });

        // Add any orphaned visible categories
        const addedIds = new Set(orderedList.map(c => c.id));
        data.forEach(c => {
          if (!addedIds.has(c.id) && c.showOnPage !== false) {
            orderedList.push({
              ...c,
              thumbnail: c.thumbnail || (c.parentId && parentMap[c.parentId] ? parentMap[c.parentId].thumbnail : "") || ""
            });
          }
        });

        const filtered = orderedList.filter(cat => !hiddenCategories.includes(cat.slug));
        setCategories(filtered);
      })
      .catch(err => console.error(err));
  }, [hiddenCategories]);

  const scroll = (direction) => {
    if (listRef.current) {
      const scrollAmount = 200;
      listRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  if (categories.length === 0) return null;

  const total = categories.length;
  let rows = [];
  if (total <= 5 || isSeoPage) {
    rows = [categories];
  } else {
    let row1Count = 0;
    if (total % 2 === 0) {
      row1Count = total / 2;
    } else {
      const halfCeil = Math.ceil(total / 2);
      if (halfCeil % 2 === 0) {
        row1Count = halfCeil;
      } else {
        row1Count = Math.floor(total / 2);
      }
    }
    rows = [
      categories.slice(0, row1Count),
      categories.slice(row1Count)
    ];
  }

  const cols = rows[0]?.length || 5;

  const renderCategoryItem = (cat) => (
    <Link
      key={cat.id}
      to={`/products?category=${cat.slug}`}
      className="category-nav-item"
    >
      <div className="category-nav-thumb">
        {cat.thumbnail ? (
          <img src={cat.thumbnail} alt={cat.name} />
        ) : (
          <i className="fas fa-seedling"></i>
        )}
      </div>
      <span className="category-nav-name">{cat.name}</span>
    </Link>
  );

  const content = (
    <div className={`category-nav-main-wrapper ${rows.length > 1 ? 'split-layout' : ''}`}>
      {rows.length === 1 ? (
        <div className="category-nav-wrapper" data-cols={cols}>
          <div className={`category-nav-list ${isSeoPage ? 'seo-grid-layout' : ''}`} ref={listRef}>
            {rows[0].map(cat => renderCategoryItem(cat))}
          </div>
        </div>
      ) : (
        <div className="category-nav-wrapper split-rows" data-cols={cols}>
          <div className="category-nav-row row-1">
            {rows[0].map(cat => renderCategoryItem(cat))}
          </div>
          <div className="category-nav-row row-2">
            {rows[1].map(cat => renderCategoryItem(cat))}
          </div>
        </div>
      )}

      {!isSeoPage && rows.length === 1 && (
        <div className="nav-controls-bottom">
          <button className="nav-arrow" onClick={() => scroll('left')}>
            <i className="fas fa-arrow-left"></i>
          </button>
          <button className="nav-arrow" onClick={() => scroll('right')}>
            <i className="fas fa-arrow-right"></i>
          </button>
        </div>
      )}
    </div>
  );

  if (isSeoPage) {
     return <div className="category-nav no-bg">{content}</div>;
  }

  return (
    <section className="category-nav">
      <div className="container">
        {content}
      </div>
    </section>
  );
};

export default CategoryNav;